import { ChatAttachmentChip } from './chat-attachments.tsx';
import type { ChatComposerAttachment } from './chat-composer-types.ts';

interface ChatComposerAttachmentListProps {
  attachments: ChatComposerAttachment[];
  onRemove?: (id: string) => void;
  removeLabel?: string;
}

/** The files picked for the next message, above the composer. */
export function ChatComposerAttachmentList({
  attachments,
  onRemove,
  removeLabel,
}: ChatComposerAttachmentListProps) {
  if (attachments.length === 0) {
    return null;
  }

  return (
    <div data-slot='chat-composer-attachments' className='flex flex-col gap-1.5 pb-2'>
      {attachments.map((attachment) => (
        <ChatAttachmentChip
          key={attachment.id}
          kind={attachment.kind}
          name={attachment.name}
          detail={attachment.detail}
          busy={attachment.uploading}
          onRemove={onRemove ? () => onRemove(attachment.id) : undefined}
          removeLabel={removeLabel}
        />
      ))}
    </div>
  );
}
